"use strict";
/*
 * Created on 02 08 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var OptimizationState;

(function (OptimizationState) {
  OptimizationState["COMPUTING"] = "computing";
  OptimizationState["FINISHED"] = "finished";
  OptimizationState["FAILED"] = "failed";
})(OptimizationState = exports.OptimizationState || (exports.OptimizationState = {}));
/**
 * Representation of optimization data computation for one {@link OptimizationGoal}.
 * Similar to {@link OptimizationGraph}. Optimized for persistent storage and export to external system.
 *
 * @author Jaroslav Sevcik
 */


var OptimizationScenario =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(OptimizationScenario, _DomainObject_1$Domai);

  /**
   *
   * @param id
   * @param categoryId
   * @param zoneId
   * @param batchComputationStart Several computations may run as part of one process (e.g. one per category and zone). This timestamp
   *        should be the same for all of these separate computations to identify the process.
   * @param optimizationId ID of an optimization job in the optimization engine.
   * @param computationState State of a computation progress.
   * @param validation Contains a relevant error, if the computation fails.
   * @param optimizationData Optimization data retrieved from the optimization engine
   */
  function OptimizationScenario(id, categoryId, zoneId, batchComputationStart, optimizationId, computationState, optimizationData, validation) {
    var _this;

    _classCallCheck(this, OptimizationScenario);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationScenario).call(this));
    _this.id = id;
    _this.categoryId = categoryId;
    _this.zoneId = zoneId;
    _this.batchComputationStart = batchComputationStart;
    _this.optimizationId = optimizationId;
    _this.computationState = computationState;
    _this.optimizationData = optimizationData;
    _this.validation = validation;
    return _this;
  }

  return OptimizationScenario;
}(DomainObject_1.DomainObject);

exports.OptimizationScenario = OptimizationScenario;